module.exports = __webpack_public_path__ + "assets/Angle60Drop.781293e498d313ab313de5f048528bdf.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Angle60Drop.gmt
// module id = 897
// module chunks = 0